import React, { useContext, useState } from 'react';
import { PageContainer } from '../../layouts';
import Input from '@material-ui/core/Input';
import FormControl from '@material-ui/core/FormControl';
import { makeStyles } from '@material-ui/core/styles';
import { Button } from '@material-ui/core';
import { UploadContext } from '../../contexts';
import { Loader } from '../../components';

const useStyles = makeStyles(() => ({
  container: {
    display: 'flex',
    flexWrap: 'wrap',
  },
  formControl: {
    margin: '10px 0 0',
  },
  input: {
    display: 'none',
  },
  label: {},
  button: {},
  title: {
    color: 'rgba(0, 0, 0, 0.38)',
    fontFamily: 'Roboto, Helvetica, Arial, sans-serif',
    fontSize: '16px',
    letterSpacing: '0.15px',
    lineHeight: '21px',
  },
  loader: {
    display: 'block',
    margin: '50px auto',
  },
}));


export default () => {
  const classes = useStyles();
  const { actions: uploadActions } = useContext(UploadContext);
  const [loading, setLoading] = useState(false);

  const uploadFileHandler = (e) => {
    setLoading(true);
    if (e.target.files[0]) {
      uploadActions.uploadFile(e.target.files[0]).then(() => setLoading(false));
    }
  };
  return (
    <PageContainer component="main" maxWidth="md">
      <div className={classes.title}>Upload files to the server</div>
      <FormControl className={classes.formControl}>
        <Input
          id="file-input"
          type="file"
          className={classes.input}
          onChange={uploadFileHandler}
        />

        {loading ? (
          <Loader size={75} className={classes.loader} />
        ) : (
          <label className={classes.label} htmlFor="file-input">
            <Button
              variant="contained"
              component="span"
              className={classes.button}
            >
              Add File
            </Button>
          </label>
        )}
      </FormControl>
    </PageContainer>
  );
};
